<script lang="ts">

    import Debug from "@/components/Debug.svelte";
    import {Badge} from "@/components/ui/badge";
    import { cn } from '@/lib/utils';

    type Props = {
        children: () => any;
        title?: string | undefined;
    };

    let {children, title}:Props = $props();
</script>

<section class="flex flex-col gap-2 w-full mx-auto bg-card rounded-lg">

    {#if title}
        <h2 class="w-full text-center">{title}</h2>
    {/if}
    {@render children?.()}
</section>

